/**
 * Punto de entrada.
 *
 * `Escape` cierra cualquier modal desde acá, una sola vez, en vez de que cada
 * popup registre su propio listener.
 */

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { useSesion } from './estado/sesion';
import './estilos.css';

document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') useSesion.getState().abrirModal(null);
});

const raiz = document.getElementById('root');
if (!raiz) throw new Error('Falta <div id="root"> en index.html');

createRoot(raiz).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
